import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const MinusCircle = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM9 15.2105C9 15.0947 9.06848 15 9.15217 15H22.8478C22.9315 15 23 15.0947 23 15.2105V16.7894C23 16.9052 22.9315 17 22.8478 17H9.15217C9.06848 17 9 16.9052 9 16.7894V15.2105Z"
        fill={color}
      />
    </svg>
  );
};

export default MinusCircle;
